import Nullstack from 'nullstack';
export default function IconEmergencyBed({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-emergency-bed",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 6h4"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v4"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v2l-2.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 16.5l-2.5 -2.5"
  }), " ");
}